import React from 'react'
import ConfirmationButton from 'components/helpers/ConfirmationButton'

const ConfirmSubscription = (props) => {
  return (
    <ConfirmationButton
      containerName={props.containerName}
      textClasses={props.textClasses}
      classes={props.buttonClasses}
      confirmationText={props.confirmationText} />
  );
}

export default ConfirmSubscription
